module.exports = __webpack_public_path__ + "media/audio.df0401cd.mp3";